export default {
	'penalty-type': 'نوع عقوبة',
	'reward-type': 'نوع مكافأة',
	fixed: 'ثابت',
	'percentage-to-hour-price': 'نسبة من سعر الساعة',
	// 'delete-message': ''
}